import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import ChiSiamo from "@/components/ChiSiamo";
import Strutture from "@/components/Strutture";
import Servizi from "@/components/Servizi";
import Team from "@/components/Team";
import Galleria from "@/components/Galleria";
import Percorso from "@/components/Percorso";
import Faq from "@/components/Faq";
import Recensioni from "@/components/Recensioni";
import Contatti from "@/components/Contatti";
import Footer from "@/components/Footer";
import StickyButtons from "@/components/StickyButtons";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Navbar />
      <Hero />
      <Marquee />
      <ChiSiamo />
      <Strutture />
      <Galleria />
      <Servizi />
      <Team />
      <Percorso />
      <Recensioni />
      <Contatti />
      <Faq />
      <Footer />
      <StickyButtons />
    </main>
  );
}
